import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { groupByMonth, getLimitDate, getDateLabels, countList, sumList } from '../../utils/statsFunctions';
import { getLabelsCustom } from './statsFunctions';

import HighChartStack from './Charts/HighChartStack';
import { Card, Grid, Box } from '@mui/material';
import { InputSelectNative } from '../common/Form';
import Currency from '../common/Currency';

class StackedStatsBank extends Component {
    state = {
        year: this.props.budget_year || new Date().getFullYear()
     }

    filterList = () => {
        const { SPENDINGS } = this.props;

        let nbPerCatlist = countList(SPENDINGS, "spending_category")
        let topCats = Object.keys(nbPerCatlist).sort( (a, b) => nbPerCatlist[b] - nbPerCatlist[a])

        return {list: SPENDINGS, topCats}
    }
    calcData = () => {
        const { CATEGORIES, start_date, end_date } = this.props;
        let sum = {}
        let series = []
        let bckg = []
        let formatted = {}
        let info = this.filterList()
        let total = 0

        let list = info.list
        let catList = info.topCats
        let dateLabels = getLabelsCustom(start_date, end_date)
        let categories = groupByMonth(list, "payment_date")
        // let categories = this.props.filter_period === "year" ? groupByMonth(list, "spending_date") : groupByDate(list, "spending_date")

        dateLabels.forEach( date => {
            sum[date] = categories[date] ? sumList(categories[date], "spending_category", "amount_bank") : {}
        })

        catList.forEach(cat => {
            Object.values(sum).forEach( data => {
                if(!formatted[cat]){
                    formatted[cat] = []
                }
                formatted[cat].push(data[cat] || 0)
            })
        })
        Object.keys(formatted).forEach( catID => {
            series.push({
                name: !isEmpty(CATEGORIES) && CATEGORIES[catID] && 
                    `${CATEGORIES[catID].category_name}`,
                data: formatted[catID],
            })
            !isEmpty(CATEGORIES) && CATEGORIES[catID] && bckg.push(CATEGORIES[catID].category_color)
            total += formatted[catID].reduce((prev, curr) => prev + curr )
        })

        return {categories : dateLabels, series, bckg, total}
    }

    render() {
        const { SPENDINGS, CATEGORIES, noDateFilter } = this.props;
        let info_stack = !isEmpty(SPENDINGS) && !isEmpty(CATEGORIES) ? this.calcData() : {}
        console.log({props: this.props});
        return (
            <Box>
                Total: <Currency value={info_stack.total} />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box p={2}>
                            {!noDateFilter &&
                                <InputSelectNative
                                    labelWidth={60}
                                    onChange={ (e) => this.setState({ year: e.target.value })}
                                    value={this.state.year}
                                    label="Année"
                                    options={[
                                        <option>{new Date().getFullYear()}</option>,
                                        <option>{new Date().getFullYear() - 1}</option>
                                    ]}
                                />
                            }
                        </Box>
                        <Card>
                            <HighChartStack 
                                title={`Dépenses Par Catégorie`}
                                // title={`Dépenses du ${new Date(this.props.start_date).toLocalDateString("fr-FR")} au ${new Date(this.props.end_date).toLocalDateString("fr-FR")}Par Catégorie`}
                                titleY="Montant FCFA"
                                type="column"
                                categories={info_stack.categories}
                                series={info_stack.series}
                                legend={false}
                                colors={info_stack.bckg}
                            />
                            
                        </Card>
                    </Grid>
                    {/* <Grid item xs={12}>
                        <Card>
                        <HighChartPie title="Répartition des ventes par abonnement" nameData="Nombre de ventes" series={info_stack.series}/>
                        </Card>
                    </Grid> */}

                </Grid>
            </Box>
        );
    }
}

export default StackedStatsBank;

